import React from 'react';

import { Stack } from '@atlaskit/primitives';

import { CtaNotifyMessageFooter, type CtaNotifyMessageFooterProps } from './CtaNotifyMessageFooter';
import { DistributionFooter, type DistributionFooterProps } from './DistributionFooter';

export type FooterProps = {
	ctaNotifyMessageFooter?: CtaNotifyMessageFooterProps;
	distributionFooter?: DistributionFooterProps;
};

export const Footer = ({ ctaNotifyMessageFooter, distributionFooter }: FooterProps) => (
	<Stack grow="fill">
		{ctaNotifyMessageFooter && <CtaNotifyMessageFooter {...ctaNotifyMessageFooter} />}
		{distributionFooter && <DistributionFooter {...distributionFooter} />}
	</Stack>
);
